import { Component } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { CpfCnpjValidator } from 'ngx-cpf-cnpj';
import { AbstractCrudComponent } from '../../component/abstract-crud.component';
import { ConfirmationDialogComponent } from '../../dialogs/confirmation-dialog/confirmation-dialog.component';
import { ErrorDialogComponent } from '../../dialogs/error-dialog/error-dialog.component';
import { PacienteDTO } from '../../dtos/paciente-dto';
import { Util } from '../../util/util';
import { CustomDateValidator } from '../../validators/custom-date-validator';
import { PacienteService } from '../paciente.service';

@Component({
  selector: 'app-paciente-list',
  templateUrl: './paciente-list.component.html',
  styleUrls: ['./paciente-list.component.css']
})
export class PacienteListComponent extends AbstractCrudComponent {

  displayedColumns: string[] = ['nome', 'dataNascimento', 'cpf', 'foneResidencial', 'foneCelular', 'details'];

  formularioDeConsultaDePaciente: FormGroup;

  filtroPaciente: PacienteDTO;

  constructor(private pacienteService: PacienteService, router: Router, dialog: MatDialog,
    private formBuilder: FormBuilder) {

    super(router, dialog);

    this.filtroPaciente = history.state.filtroPaciente;

    this.formularioDeConsultaDePaciente = this.formBuilder.group({
      nome: ['', [Validators.minLength(3)]],
      cpf: ['', [CpfCnpjValidator.validate]],
      dataNascimento: [''],
    }, {
      validator: CustomDateValidator('dataNascimento')
    });
  }

  ngOnInit() {

    if (this.filtroPaciente && (this.filtroPaciente.nome || this.filtroPaciente.cpf || this.filtroPaciente.dataNascimento)) {
      
      this.formularioDeConsultaDePaciente.setValue(this.filtroPaciente);

      this.reloadData(this.filtroPaciente);
    }

    super.ngOnInit();
  }

  reloadData(pacienteDTO: PacienteDTO) {

    if (!pacienteDTO.nome && !pacienteDTO.cpf && !pacienteDTO.dataNascimento) {

      this.dialog.open(ErrorDialogComponent, {
        data: {
          title: 'Erro',
          message: 'Selecione pelo menos um campo de filtro!'
        }
      });

    } else {

      this.pacienteService.procurarPacientePorFiltroComProjecao(pacienteDTO)
        .subscribe(data => {
          // console.log(data)
          this.data = data;
          this.configurarDataSource();
        }, error => {
          console.log(error);
        });

    }
  }

  onSubmit() {
    this.filtroPaciente = this.formularioDeConsultaDePaciente.value;

    this.reloadData(this.filtroPaciente);
  }

  confirmDelete(id: number) {
    const confirmDialog = this.dialog.open(ConfirmationDialogComponent, {
      data: {
        title: 'Confirmação de exclusão',
        message: 'Deseja realmente remover essa informação ?'
      }
    });
    confirmDialog.afterClosed().subscribe(result => {
      if (result === true) {
        this.delete(id);
      }
    });
  }

  delete(id: number) {
    this.pacienteService.remover(id)
      .subscribe(
        data => {
          // console.log(data);
          this.reloadData(this.filtroPaciente);
        },
        error => {
          console.log(error);
        });
  }

  add() {
    this.router.navigate(['manterPaciente']);
  }

  details(id: number) {

    const pacienteDTO: PacienteDTO = this.formularioDeConsultaDePaciente.value;

    this.router.navigate(['manterPaciente'], {
      state: {
        id: id,
        isUpdate: 'N',
        filtroPaciente: pacienteDTO,
      }
    });
  }

  update(id: number) {

    const pacienteDTO: PacienteDTO = this.formularioDeConsultaDePaciente.value;

    this.router.navigate(['manterPaciente'], {
      state: {
        id: id,
        isUpdate: 'S',
        filtroPaciente: pacienteDTO,
      }
    });
  }

  pattern = Util.pattern;

}
